<template>
  <el-dropdown ref="iconFontSelectorDropMenu"
               class="icon-font-selector"
               placement="bottom-start"
               trigger="click"
               :hide-on-click="true">
    <slot></slot>
    <el-dropdown-menu class="icon-font-selector-drop" slot="dropdown">
      <div class="drop-menu-header ">
        <span>选择图标</span>
      </div>
      <AppScrollbar style="height: 150px">
        <div class="drop-menu-body">
          <el-row>
            <el-col :xs="3" :sm="3" v-for="(fontIcon, index) in fontIconList" :key="'icon-font-' + index">
              <div class="icon-font-item" :class="{'is-selected': fontIcon === inputRef}" @click="selectFontIcon(fontIcon)">
                <i :class="fontIcon"></i>
              </div>
            </el-col>
          </el-row>
        </div>
      </AppScrollbar>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import AppScrollbar from '../elements/AppScrollbar'
export default {
  name: 'IconFontSelector',
  components: {AppScrollbar},
  props: {
    inputRef: String
  },
  data () {
    return {
      iconClasses: [
        'icon-minimum',
        'icon-maximize',
        'icon-xiaoxi',
        'icon-laptop',
        'icon-help',
        'icon-excel',
        'icon-cpu',
        'icon-alter',
        'icon-edit',
        'icon-tag',
        'icon-pie-chart',
        'icon-strategy',
        'icon-policy',
        'icon-error',
        'icon-error-bold',
        'icon-send',
        'icon-bug',
        'icon-disk',
        'icon-like',
        'icon-tv',
        'icon-order-response',
        'icon-phone',
        'icon-approve',
        'icon-dialog',
        'icon-import',
        'icon-export',
        'icon-order',
        'icon-correct',
        'icon-correct-bold',
        'icon-publish',
        'icon-home',
        'icon-magnifier',
        'icon-server',
        'icon-alarm',
        'icon-tool',
        'icon-shut-down',
        'icon-merge',
        'icon-institute',
        'icon-staff',
        'icon-user',
        'icon-asset',
        'icon-aid',
        'icon-deblock',
        'icon-lock',
        'icon-ban',
        'icon-serve',
        'icon-lound-speaker',
        'icon-link',
        'icon-memory',
        'icon-start',
        'icon-migrate',
        'icon-pencil',
        'icon-cancel',
        'icon-calendar',
        'icon-top-bold',
        'icon-bottom',
        'icon-top',
        'icon-right',
        'icon-right-bold',
        'icon-bottom-bold',
        'icon-left',
        'icon-left-bold',
        'icon-upload-pic',
        'icon-community',
        'icon-clock',
        'icon-authorise',
        'icon-window',
        'icon-event',
        'icon-data-base',
        'icon-back-circle',
        'icon-refresh-circle',
        'icon-refresh-square',
        'icon-back-square',
        'icon-attend',
        'icon-attended',
        'icon-picture',
        'icon-network',
        'icon-order-mine',
        'icon-info',
        'icon-info-read',
        'icon-pause',
        'icon-message',
        'icon-middleware',
        'icon-finish',
        'icon-folder',
        'icon-midware',
        'icon-histogram',
        'icon-panel',
        'icon-unknow',
        'icon-net-device',
        'icon-compass',
        'icon-cloud',
        'icon-add',
        'icon-app',
        'icon-file',
        'icon-email',
        'icon-hardware',
        'icon-screen',
        'icon-star-full',
        'icon-star-empty',
        'icon-set-place',
        'icon-set',
        'icon-account-audit',
        'icon-config-account',
        'icon-eye',
        'icon-knowledge-base',
        'icon-wechat',
        'icon-update',
        'icon-self-test',
        'icon-backup',
        'icon-bulletin',
        'icon-union',
        'icon-protocol',
        'icon-funnel',
        'icon-reduce',
        'icon-enlarge',
        'icon-sponsor',
        'icon-stop',
        'icon-scan-address',
        'icon-snmp-response',
        'icon-line',
        'icon-nav-log-center',
        'icon-nav-process-center',
        'icon-nav-account-manage',
        'icon-nav-oper-center',
        'icon-nav-event-center',
        'icon-nav-system-set',
        'icon-nav-asset-monitor',
        'icon-nav-asset-manage',
        'icon-nav-self-service',
        'icon-minus',
        'icon-minus-bold',
        'icon-plus-bold',
        'icon-plus',
        'icon-frequency',
        'icon-delete',
        'icon-organ',
        'icon-account-asset',
        'icon-manage-author',
        'icon-config-safe',
        'icon-account-isolate',
        'icon-position',
        'icon-aim',
        'icon-source',
        'icon-config-audit',
        'icon-asset-expired',
        'icon-asset-change',
        'icon-roadblock',
        'icon-tag2',
        'icon-inspection',
        'icon-trophy',
        'icon-briefcase',
        'icon-mib',
        'icon-cabinet',
        'icon-config-ip',
        'icon-week',
        'icon-month',
        'icon-day',
        'icon-set-alarm',
        'icon-batch-add',
        'icon-batch-reduce',
        'icon-batch-del',
        'icon-batch-import',
        'icon-batch-export',
        'icon-flag',
        'icon-oper-apply',
        'icon-business-server',
        'icon-oper-equip',
        'icon-log',
        'icon-download',
        'icon-batch-execution',
        'icon-assist',
        'icon-announce',
        'icon-special-oper',
        'icon-system-statu',
        'icon-early-warn',
        'icon-delegate',
        'icon-receive',
        'icon-order-track',
        'icon-query-knowledge',
        'icon-set-process',
        'icon-manage-process',
        'icon-order-add',
        'icon-order-pending',
        'icon-config-rule',
        'icon-config-command',
        'icon-official-edition',
        'icon-linux',
        'icon-mac',
        'icon-windows',
        'icon-link-equip',
        'icon-activation',
        'icon-config-link-audit',
        'icon-after-change-psw',
        'icon-before-change-psw',
        'icon-port',
        'icon-association',
        'icon-inquire',
        'icon-list',
        'icon-engine-room',
        'icon-batch-oper',
        'icon-straight',
        'icon-entity',
        'icon-orthogonal',
        'icon-curve',
        'icon-align-vertical',
        'icon-align-bottom',
        'icon-align-level',
        'icon-align-top',
        'icon-align-right',
        'icon-align-left',
        'icon-layout',
        'icon-full-screen',
        'icon-cancel-full-screen',
        'icon-capture-screen',
        'icon-click',
        'icon-business-translate',
        'icon-vcr',
        'icon-camera',
        'icon-timer',
        'icon-nav-set-oper',
        'icon-rocket',
        'icon-battery',
        'icon-business-monitor',
        'icon-double-left',
        'icon-double-right',
        'icon-most-bottom',
        'icon-most-left',
        'icon-most-top',
        'icon-most-right',
        'icon-arrow-right',
        'icon-arrow-bottom',
        'icon-arrow-top',
        'icon-arrow-left',
        'icon-resource',
        'icon-ruler',
        'icon-info-query',
        'icon-last-time',
        'icon-signal',
        'icon-no-signal',
        'icon-arrow-right-bottom',
        'icon-arrow-right-top',
        'icon-arrow-left-bottom',
        'icon-arrow-left-top',
        'icon-reboot',
        'icon-assist-cancel',
        'icon-carry-out',
        'icon-retreat',
        'icon-shopping-cart',
        'icon-clean-up',
        'icon-u-disk',
        'icon-medal',
        'icon-money',
        'icon-fire',
        'icon-cd',
        'icon-blackboard',
        'icon-scissors',
        'icon-pin',
        'icon-monitor',
        'icon-box-select',
        'icon-printer',
        'icon-mouse',
        'icon-lightning',
        'icon-quit-s',
        'icon-nav-oper-center-t',
        'icon-attended-full',
        'icon-change-psw',
        'icon-downtime',
        'icon-not-pass',
        'icon-close-eye',
        'icon-open-eye',
        'icon-scan',
        'icon-qr-code',
        'icon-account-only',
        'icon-underway',
        'icon-prompt-info',
        'icon-sort',
        'icon-cloud-down',
        'icon-paper-clip',
        'icon-word',
        'icon-bangding',
        'icon-bind-remove',
        'icon-cloud1',
        'icon-pdf',
        'icon-order-close',
        'icon-email-failed',
        'icon-sms-success',
        'icon-email-success',
        'icon-sms-failed',
        'icon-protocol-add',
        'icon-asset-add',
        'icon-protocol-audit',
        'icon-qq',
        'icon-menu-fold',
        'icon-menu-unfold',
        'icon-oper-auto-1',
        'icon-oper-auto',
        'icon-console',
        'icon-sys-enhance'
      ]
    }
  },
  computed: {
    fontIconList: function () {
      let fontIcons = []
      this.iconClasses.forEach((value, index) => {
        fontIcons.push(['iconfont', value].join(' '))
      })
      return fontIcons
    }
  },
  methods: {
    selectFontIcon (fontIcon) {
      this.$refs['iconFontSelectorDropMenu'].hide()
      this.$emit('update:inputRef', fontIcon)
    }
  }
}
</script>

<style lang="scss">
  .icon-font-selector {
    display: block!important;
  }
  .icon-font-selector-drop {
    width: 360px;
    max-width: 100%;
    .drop-menu-header {
      padding: 5px 10px 10px;
      font-size: 12px;
      color: #909399;
      line-height: 20px;
      border-bottom: 1px solid #ebeef5;
    }
    .drop-menu-body {
      padding: 5px 10px 0;
      height: 150px;
      .icon-font-item {
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        &.is-selected {
          transform: scale(1.2);
          i {
            color: #e6a23c!important;
          }
        }
        &:hover {
          transform: scale(1.2);
          i {
            color: #303133;
          }
        }
        i {
          color: #999;
          font-size: 16px;
        }
      }
    }
  }
</style>
